// components/ComponentMap.ts

import HeroSectionV2Container from "../banner/v2/HeroSectionV2Container";
import HeaderWrapper from "../header/HeaderWrapper";
import TopSellingWithBanner from "../product/TopSellingWithBanner";
import CategoryWithSlider from "../category/CategorySlider";
import BrandImageSlider from "../brand/BrandImageSlider";
// import SiteFeature from "../homepage/SiteFeature";
// import TriplePromotionalBanner from "../promotional/TriplePromotionalBanner";
import FooterV2 from "../footer/FooterV2";

// import AdditionalSlider from "../banner/AdditionalSliders";
import SliderWithOnePromo from "../banner/SliderWithOnePromo";
import TrendingCategoriesV2 from "../category/TrendingCategoriesV2";

export const ComponentMap: Record<
  string,
  React.ComponentType<Record<string, unknown>>
> = {
  1: HeaderWrapper,
  2: HeroSectionV2Container,
  3: TrendingCategoriesV2, // Redesigned product-tab category section
  4: TopSellingWithBanner,
  5: CategoryWithSlider,
  6: SliderWithOnePromo,
  7: BrandImageSlider,
  // 9: SiteFeature,
  // 10: AdditionalSlider,
  // 10: Banner,
  // 11: ShopByCategory, // Reserved legacy categories view on key 11
  // 12: TriplePromotionalBanner,
  13: FooterV2,
  // 14: AboutUs,
};
